import { SVGProps } from 'react';

export const CloudOutline = ({
  width = 16,
  height = 16,
  fill = '#494949',
  className,
}: SVGProps<SVGElement>): JSX.Element => (
  <svg
    width={width}
    height={height}
    fill={fill}
    version="1.1"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <g>
      <path
        d="M9.25,21.29c-1.71,0-3.32-0.88-4.27-2.29c-1.2-0.03-2.37-0.49-3.28-1.31C0.62,16.71,0,15.32,0,13.88
            c0-1.36,0.53-2.64,1.47-3.59c-0.06-0.33-0.09-0.66-0.09-1c0-3.08,2.5-5.58,5.58-5.58c0,0,0,0,0.01,0c1.29,0,2.53,0.45,3.51,1.25
            c0.79-0.52,1.69-0.76,2.67-0.79c1.34,0,2.61,0.56,3.53,1.51c0.42-0.09,0.85-0.14,1.28-0.14c3.33,0,6.04,2.71,6.04,6.04
            c0,3.33-2.71,6.04-6.04,6.04c-0.03,0-0.05,0-0.08,0c-0.92,1.15-2.33,1.86-3.82,1.83c0,0,0,0-0.01,0c-0.28,0-0.55-0.02-0.82-0.07
            C12.27,20.58,10.8,21.29,9.25,21.29z M6.14,16.91l0.31,0.63c0.52,1.06,1.62,1.75,2.81,1.75c1.1,0,2.14-0.59,2.7-1.55l0.41-0.71
            l0.77,0.27c0.3,0.1,0.61,0.15,0.92,0.15c0,0,0.01,0,0.01,0c1,0,1.94-0.53,2.46-1.39l0.34-0.56l0.65,0.08
            c0.15,0.02,0.3,0.03,0.45,0.03c2.23,0,4.04-1.81,4.04-4.04c0-2.23-1.81-4.04-4.04-4.04c-0.45,0-0.89,0.07-1.31,0.22L15.94,8
            l-0.43-0.61c-0.54-0.77-1.43-1.22-2.37-1.23c-0.74,0.02-1.48,0.29-2.02,0.83l-0.76,0.76l-0.7-0.81C8.98,6.16,8,5.71,6.96,5.71
            c0,0,0,0,0,0c-1.98,0-3.58,1.61-3.58,3.58c0,0.35,0.05,0.71,0.16,1.05L3.74,11l-0.54,0.42C2.44,12.01,2,12.91,2,13.87
            c0,0.88,0.38,1.73,1.04,2.33c0.66,0.6,1.52,0.88,2.4,0.78L6.14,16.91z"
      />
    </g>
  </svg>
);
